import React from 'react'
import { observer } from "mobx-react";
import { ActionDto, ManagerDto } from 'src/stores/models/qarFormModels';
import { Dialog, DialogTitle, FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import { Button, DialogActions, DialogContent } from '@material-ui/core';
import { EmployeeReviewActions } from 'src/stores/models/enums';
import { useStores } from 'src/stores/rootStore';


export const QARFormActionSelect = observer(({ action, actionChanges }: { action: ActionDto, actionChanges: ActionDto }) => {

    const { qarFormStore, uiStateStore } = useStores();

    // const handleOriginalActionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    //     action.name = event.target.value as EmployeeReviewActions
    // }

    const handleActionChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        actionChanges.name = event.target.value as EmployeeReviewActions
        qarFormStore.setBulkReviewsIndeterminate();

        if ((action.name === EmployeeReviewActions.Change || action.name === EmployeeReviewActions.Revoked) &&
            actionChanges.name === action.name) {
            actionChanges.comment = action.comment;
            actionChanges.ticketId = action.ticketId;
        } else {
            actionChanges.comment = '';
            actionChanges.ticketId = '';
        }

        if ((action.name === EmployeeReviewActions.Change || action.name === EmployeeReviewActions.Revoked) &&
            action.name !== actionChanges.name) {
            uiStateStore.setModalContent(getModalContent())
            uiStateStore.setModalOpen(true)
        }
    }

    const closeWarningPopup = () => {
        uiStateStore.setModalOpen(false);
        uiStateStore.setModalContent(undefined);
    }

    const cancelWarningPopup = () => {
        actionChanges.name = action.name;
        actionChanges.comment = action.comment;
        actionChanges.ticketId = action.ticketId;
        uiStateStore.setModalOpen(false);
        uiStateStore.setModalContent(undefined);
    }

    const getModalContent = () => {
        return (
            <Dialog open={true} onClose={cancelWarningPopup} maxWidth='lg'>
                <DialogTitle>Attention!</DialogTitle>
                <DialogContent dividers={true}>
                    <p>You have a ticket corresponding with this action:</p>
                    <p><a className="no-facelift" href={action.ticketId} target='_blank' rel="noreferrer">{action.ticketId}</a></p>
                    <p>You have to modify the ticket manually when you change the action.</p>
                    <p>Notify responsible departments accordingly.</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelWarningPopup} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={closeWarningPopup} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    const getTicketId = (ticketLink: string) => {
        if (!ticketLink) return
        const ticketId = ticketLink?.match(/[^/]*$/)
        return ticketId
    };

    const renderFormControl = () => {

        if (actionChanges.delegatedTo !== null) {
            return (
                <FormControl className="qar-form-control-select-action-wrapper" disabled>
                    {/* <InputLabel id="qar-form-control-select-action-label">Select action</InputLabel> */}
                    <Select
                        labelId="qar-form-control-select-action-label"
                        id="qar-form-control-select-action"
                        value={EmployeeReviewActions.DelegatedTo}
                        readOnly={true}
                    >
                        <MenuItem value={EmployeeReviewActions.DelegatedTo}>Delegating</MenuItem>
                    </Select>
                    <FormHelperText>to {actionChanges.delegatedTo.fullName}</FormHelperText>
                </FormControl>
            );
        }

        if (qarFormStore.selectedQuarter && new Date(qarFormStore.selectedQuarter.reviewDeadline) < new Date()) {

            if (actionChanges.valid === false && actionChanges.name !== EmployeeReviewActions.Revoked
                && actionChanges.name !== EmployeeReviewActions.Change) {
                return (
                    <FormControl className="qar-form-control-select-action-wrapper" error required>
                        {/* <InputLabel id="qar-form-control-select-action-label">Select action</InputLabel> */}
                        <Select
                            labelId="qar-form-control-select-action-label"
                            id="qar-form-control-select-action"
                            onChange={handleActionChange}
                            value={actionChanges.name}
                        >
                            {/* <MenuItem value="">
                                <em>Select action</em>
                            </MenuItem> */}
                            <MenuItem value={EmployeeReviewActions.MissingAction}>None</MenuItem>
                            <MenuItem value={EmployeeReviewActions.Approved}>{EmployeeReviewActions[EmployeeReviewActions.Approved]}</MenuItem>
                            <MenuItem value={EmployeeReviewActions.Revoked}>{EmployeeReviewActions[EmployeeReviewActions.Revoked]}</MenuItem>
                            <MenuItem value={EmployeeReviewActions.Change}>{EmployeeReviewActions[EmployeeReviewActions.Change]}</MenuItem>
                            {/* <MenuItem value={EmployeeReviewActions.DelegatedTo}>{EmployeeReviewActions[EmployeeReviewActions.DelegatedTo]}</MenuItem> */}
                        </Select>
                        <FormHelperText>Required</FormHelperText>
                    </FormControl>
                );
            }

            if (action.name !== EmployeeReviewActions.MissingAction) {

                switch (action.name) {
                    case EmployeeReviewActions.DelegatedTo:
                        return (
                            <FormControl className="qar-form-control-select-action-wrapper" disabled>
                                {/* <InputLabel id="qar-form-control-select-action-label">Selected action</InputLabel> */}
                                <Select
                                    labelId="qar-form-control-select-action-label"
                                    id="qar-form-control-select-action"
                                    value={action.name}
                                    readOnly={true}
                                >
                                    <MenuItem value={EmployeeReviewActions.DelegatedTo}>Delegated</MenuItem>
                                </Select>
                                <FormHelperText>to {(action.delegatedTo as ManagerDto).fullName}</FormHelperText>
                            </FormControl>
                        );


                    case EmployeeReviewActions.Change:
                    case EmployeeReviewActions.Revoked:
                        return (
                            <FormControl className="qar-form-control-select-action-wrapper" disabled>
                                {/* <InputLabel id="qar-form-control-select-action-label">Selected action</InputLabel> */}
                                <Select
                                    labelId="qar-form-control-select-action-label"
                                    id="qar-form-control-select-action"
                                    value={action.name}
                                    readOnly={true}
                                >
                                    <MenuItem value={EmployeeReviewActions.Revoked}>{EmployeeReviewActions[EmployeeReviewActions.Revoked]}</MenuItem>
                                    <MenuItem value={EmployeeReviewActions.Change}>{EmployeeReviewActions[EmployeeReviewActions.Change]}</MenuItem>
                                </Select>
                                <FormHelperText style={{ fontWeight: "bold" }}>Ticket link: <a className="no-facelift" target="_blank" rel="noreferrer" href={action.ticketId}>{getTicketId(action.ticketId)}</a></FormHelperText>
                            </FormControl>
                        );

                    default:
                        return (
                            <FormControl className="qar-form-control-select-action-wrapper" disabled>
                                {/* <InputLabel id="qar-form-control-select-action-label">Selected action</InputLabel> */}
                                <Select
                                    labelId="qar-form-control-select-action-label"
                                    id="qar-form-control-select-action"
                                    value={action.name}
                                    readOnly={true}
                                >
                                    <MenuItem value={EmployeeReviewActions.Approved}>{EmployeeReviewActions[EmployeeReviewActions.Approved]}</MenuItem>
                                </Select>
                                {/* <FormHelperText>Required</FormHelperText> */}
                            </FormControl>
                        );
                }
            }

            return (
                <FormControl className="qar-form-control-select-action-wrapper" required>
                    {/* <InputLabel id="qar-form-control-select-action-label">Select action</InputLabel> */}
                    <Select
                        labelId="qar-form-control-select-action-label"
                        id="qar-form-control-select-action"
                        onChange={handleActionChange}
                        value={actionChanges.name}
                    >
                        {/* <MenuItem value="">
                            <em>Select action</em>
                        </MenuItem> */}
                        <MenuItem value={EmployeeReviewActions.MissingAction}>None</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Approved}>{EmployeeReviewActions[EmployeeReviewActions.Approved]}</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Revoked}>{EmployeeReviewActions[EmployeeReviewActions.Revoked]}</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Change}>{EmployeeReviewActions[EmployeeReviewActions.Change]}</MenuItem>
                        {/* <MenuItem value={EmployeeReviewActions.DelegatedTo}>{EmployeeReviewActions[EmployeeReviewActions.DelegatedTo]}</MenuItem> */}
                    </Select>
                    <FormHelperText>Required</FormHelperText>
                </FormControl>
            );
        }

        if ((action.name === EmployeeReviewActions.Change || action.name === EmployeeReviewActions.Revoked) &&
            actionChanges.name === action.name) {
            return (
                <FormControl className="qar-form-control-select-action-wrapper">
                    {/* <InputLabel id="qar-form-control-select-action-label">Select action</InputLabel> */}
                    <Select
                        labelId="qar-form-control-select-action-label"
                        id="qar-form-control-select-action"
                        onChange={handleActionChange}
                        value={actionChanges.name}
                    >
                        <MenuItem value={EmployeeReviewActions.MissingAction}>None</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Approved}>{EmployeeReviewActions[EmployeeReviewActions.Approved]}</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Revoked}>{EmployeeReviewActions[EmployeeReviewActions.Revoked]}</MenuItem>
                        <MenuItem value={EmployeeReviewActions.Change}>{EmployeeReviewActions[EmployeeReviewActions.Change]}</MenuItem>
                    </Select>
                    <FormHelperText style={{ fontWeight: "bold" }}>Ticket link: <a className="no-facelift" target="_blank" rel="noreferrer" href={action.ticketId}>{getTicketId(action.ticketId)}</a></FormHelperText>
                </FormControl>
            );
        }

        return (
            <FormControl className="qar-form-control-select-action-wrapper">
                {/* <InputLabel id="qar-form-control-select-action-label">Select action</InputLabel> */}
                <Select
                    labelId="qar-form-control-select-action-label"
                    id="qar-form-control-select-action"
                    onChange={handleActionChange}
                    value={actionChanges.name}
                >
                    {/* <MenuItem value="">
                        <em>Select action</em>
                    </MenuItem> */}
                    <MenuItem value={EmployeeReviewActions.MissingAction}>None</MenuItem>
                    <MenuItem value={EmployeeReviewActions.Approved}>{EmployeeReviewActions[EmployeeReviewActions.Approved]}</MenuItem>
                    <MenuItem value={EmployeeReviewActions.Revoked}>{EmployeeReviewActions[EmployeeReviewActions.Revoked]}</MenuItem>
                    <MenuItem value={EmployeeReviewActions.Change}>{EmployeeReviewActions[EmployeeReviewActions.Change]}</MenuItem>
                    {/* <MenuItem value={EmployeeReviewActions.DelegatedTo}>{EmployeeReviewActions[EmployeeReviewActions.DelegatedTo]}</MenuItem> */}
                </Select>
                {/* <FormHelperText>Required</FormHelperText> */}
            </FormControl>
        );
    }

    return (
        <>
            {renderFormControl()}
        </>
    );

});